import { jwtDecode } from "jwt-decode";

export const getCurrentUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    
   
    return { 
      ...decoded,  
      admin: String(decoded.admin).toLowerCase() === "true" 
    };
  } catch {
    return null;
  }
};